module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7FGSu"))).then(() => module.bundle.root('ikE14'));